/* globals lp, rxSwitchboard */
var Rx = require('ub_wrapped/rx');
var _ = require('lodash');

var ubBanzai = window.ubBanzai;

;(function(){
  lp.PerfSampling = (function(){
    var _perfSamples         = new Rx.Subject()
      , _perfSamplingPeriod  = ubBanzai.getFeatureValue('perfSamplingPeriod')
      , _perfSamplingMaxSize = ubBanzai.getFeatureValue('perfSamplingMaxSize');

    var _storePerfEvent     = _perfSamples.onNext.bind(_perfSamples)
      , _sampleObservables  = {}
      , _samplingDisposable = null;

    var _isSamplingOn = function() {
      return !!_samplingDisposable;
    };

    var _augmentedSamples = _perfSamples
      .timestamp()
      .map(function(ev){
        ev.value.sessionId = lp.getSessionIdWithSaveIncrement();
        ev.value.timestamp = ev.timestamp;
        return ev.value;
      });

    var _bufferedSamples = _augmentedSamples
      .bufferWithTimeOrCount(_perfSamplingPeriod, _perfSamplingMaxSize);

    var getActiveSources = function() {

      var activeSourceNames = ubBanzai.getFeatureValue('activePerfSamples') || []
        , activeSources     = _.pick(_sampleObservables, activeSourceNames);

      return _.map(_.pairs(activeSources), function(pair){
        var name = pair[0]
          , obs  = pair[1];
        return obs.map(function(ev){
          ev.type = name;
          return ev;
        });
      });
    };

    var _activateSamples = function() {
      if(_samplingDisposable && !_samplingDisposable.isDisposed) {
        _samplingDisposable.dispose();
      }

      _samplingDisposable = Rx.Observable
        .merge
        .apply(Rx.Observable, getActiveSources())
        .subscribe(_storePerfEvent);
    };

    var _registerSampleSource = function(name, observable) {
      _sampleObservables[name] = observable;
      if(_isSamplingOn()) {
        _activateSamples();
      }
    };

    var _startSampling = function() {
      rxSwitchboard.subjects
        .first_page_load
        .subscribe(function(){
          _activateSamples();
        });
    };

    return {
      registerSampleSource: _registerSampleSource,
      startSampling: _startSampling,
      bufferedSamplesObs: _bufferedSamples
    };

  })();

  if(ubBanzai.features.isPerfSamplingEnabled()) {
    lp.PerfSampling.startSampling();
  }

})();



//////////////////
// WEBPACK FOOTER
// ./src/legacy/lp/editor/performance/perf_sampling.js
// module id = 1064
// module chunks = 0